import { type CountryCode, type ProjectCode } from '@constants'
import { useMemo } from 'react'
import * as couponService from '../../core/couponService'
import { parserFastpassOrderItemBySkuMap } from '../../parser/parserFastpassOrderItemBySkuMap'
import { type PlatformType } from './store-map'
import { useFpB2bCartCalculate } from './use-fp-b2b-cart-calculate'
import { useFpB2bCartService } from './use-fp-b2b-cart-service'
import { useFpB2bProductsInfo } from './use-fp-b2b-products-info'

export interface UseFpB2bCartItemValuesArgs {
  campaignId: number
  projectCode: ProjectCode
  countryCode: CountryCode
  campaignCode?: string
  platform: PlatformType
}

export const useFpB2bCartItemValues = (args: UseFpB2bCartItemValuesArgs) => {
  const { campaignId, projectCode, countryCode, campaignCode, platform } = args
  const { items: cartItems } = useFpB2bCartService(campaignId, platform)
  const { calculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)
  const orderItemBySkuMap = useMemo(() => parserFastpassOrderItemBySkuMap(calculateResult?.order_items), [calculateResult])
  const { productMap } = useFpB2bProductsInfo({ projectCode, countryCode, campaignCode, campaignId, platform })

  const cartItemsValues = useMemo(() =>
    cartItems.map((item) => {
      /**
       * 如果是 butler item 就用 variation_id
       */
      const product = !!item.butler.orderItemId ? productMap?.[item.variation_id] : productMap?.[item.cartItemId]
      if (!product) return null
      const orderItemFromCalculate = orderItemBySkuMap[item.sku]
      const { stock } = couponService.getCartListItemProps(item, product, orderItemFromCalculate)
      return {
        cartItemId: item.cartItemId,
        stock,
        quantity: item.quantity,
        delivery_class: product.delivery_class,
        subship_info: item.subship_info,
        isDeleted: item.butler.isDeleted,
        parent_product_id: item.parent_product_id,
        parent_product_purchased_limit: item.parent_product_purchased_limit,
      }
    }).filter(value => value !== null), [cartItems, orderItemBySkuMap, productMap])

  return cartItemsValues
}
